const carouselItems = [
  {
    title: '玄幻巅峰 · 斗破苍穹',
    subtitle: '萧炎异火之路全回顾',
    desc: '从三年之约到云岚宗决战，跟随萧炎的脚步重温这部玄幻经典的每一个热血瞬间。全彩重制版正在51漫画在线独家连载中。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20epic%20manga%20banner%20illustration%2C%20a%20warrior%20surrounded%20by%20multicolored%20flames%20in%20dramatic%20combat%20pose%2C%20warm%20orange%20and%20gold%20color%20scheme%2C%20cinematic%20wide%20composition%2C%20clean%20minimal%20background%20with%20fire%20effects%2C%20modern%20anime-inspired%20art%20style&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '国漫之光 · 狐妖小红娘',
    subtitle: '镜花缘篇绝美回顾',
    desc: '涂山红红与东方月初跨越千年的爱情故事，镜花缘篇以极致唯美画风诠释了何为"相思树下说相思"。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20romantic%20manga%20banner%20illustration%2C%20a%20couple%20standing%20under%20a%20giant%20cherry%20blossom%20tree%20with%20magical%20glowing%20petals%2C%20warm%20pink%20and%20gold%20color%20scheme%2C%20cinematic%20wide%20composition%2C%20dreamy%20soft%20lighting%2C%20modern%20anime-inspired%20art%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '异人江湖 · 一人之下',
    subtitle: '罗天大醮经典战役',
    desc: '张楚岚与王也在龙虎山的巅峰对决，异能世界的规则被逐一揭开。51漫画免费看全集回顾异人之旅。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20urban%20supernatural%20manga%20banner%20illustration%2C%20two%20characters%20facing%20off%20in%20a%20modern%20city%20at%20night%20with%20energy%20effects%2C%20warm%20amber%20and%20deep%20blue%20color%20scheme%2C%20cinematic%20wide%20composition%2C%20dramatic%20lighting%2C%20modern%20anime-inspired%20art%20style&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '星海征途 · 星辰变',
    subtitle: '全彩重制版全新上线',
    desc: '秦羽从凡人到宇宙之主的传奇旅程，全彩重制版在51漫画在线首发。高清重绘让星空更加壮丽。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20celestial%20manga%20banner%20illustration%2C%20a%20character%20floating%20in%20space%20surrounded%20by%20stars%20and%20galaxies%2C%20deep%20indigo%20and%20silver%20color%20scheme%2C%20cinematic%20wide%20composition%2C%20cosmic%20atmosphere%2C%20modern%20anime-inspired%20art%20style&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '新锐力量 · 原创漫画',
    subtitle: '发掘下一部神作',
    desc: '51漫画网持续扶持原创漫画作者，每周上新精选原创作品。下一个现象级IP可能就在今天的更新里。',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20creative%20manga%20banner%20illustration%2C%20multiple%20diverse%20characters%20in%20different%20art%20styles%20gathered%20together%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20cinematic%20wide%20composition%2C%20celebratory%20atmosphere%2C%20modern%20anime-inspired%20art%20style&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-600">51漫画在线精选专题，深度探索你喜爱的漫画世界</p>
        </div>

        <div className="flex flex-col gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all group flex flex-col md:flex-row"
            >
              <div className="w-full md:w-[320px] flex-shrink-0 overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 aspect-[16/10] md:aspect-auto md:h-full"
                />
              </div>
              <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                <span className="text-xs text-accent-600 font-medium mb-2">{item.subtitle}</span>
                <h3 className="text-heading text-xl md:text-2xl text-foreground-900 mb-3">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.desc}</p>
                <a
                  href="#ranking"
                  onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
                  className="self-start inline-flex items-center gap-1.5 text-sm text-primary-500 font-medium no-underline cursor-pointer hover:text-primary-600"
                >
                  探索更多 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}